import { render, staticRenderFns } from "./UpdateBannerDialog.vue?vue&type=template&id=309b5248&scoped=true&lang=pug&"
import script from "./UpdateBannerDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateBannerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b5248",
  null
  
)

export default component.exports